import type { CSSProperties, ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

// Revisión en vivo 2026-09-22, punto #4C: el portal tiene ocho
// `<p role="status">` / `<p role="alert">` sueltos en cinco archivos, la
// mayoría sin ningún `style`, mientras dos estilos propios ya existían sin
// reusarse: `FieldError` (FormLayout.tsx, rojo/danger) y el `hint` de `Field`
// (FormField.tsx, texto tenue). Acá quedan los dos como variantes con nombre;
// ningún valor es nuevo: salen verbatim de esos dos lugares.
//
// `style` se mezcla al final para que quien las use pueda ajustar solo el
// espaciado del contexto (un `marginTop`, un `margin: 0`) sin volver a
// redeclarar la tipografía ni el color — que es exactamente cómo se
// desparramaron los estilos ad-hoc que este punto viene a unificar.

/**
 * Aviso tenue de estado o ayuda (`role="status"`, anuncio cortés). Tipografía
 * y color del `hint` de `Field` (FormField.tsx).
 */
export function StatusText({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <div
      role="status"
      style={{
        font: `400 11px/1.45 ${tokens.font.ui}`,
        color: tokens.text.disabled,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

/**
 * Aviso de error o de riesgo (`role="alert"`, anuncio asertivo). Tipografía y
 * color de `FieldError` (FormLayout.tsx), que pasa a apoyarse en esta variante.
 */
export function AlertText({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <div
      role="alert"
      style={{
        font: `500 11.5px ${tokens.font.ui}`,
        color: tokens.danger.base,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
